import { attachEvent } from '../../../utils/base.utils';

export function loadDropddownEvents() {
	// Shared function to toggle dropdown
	const toggleDropdown = (activeDropdownLink, evt, isKeyboardActivated = false) => {
		evt.stopPropagation();
		var activeDropdown = activeDropdownLink.closest('.ad-component_dropdown');
		const isCurrentlyActive = activeDropdown.classList.contains('js-dropdown-active');
		
		[].forEach.call(document.querySelectorAll('.ad-universalnav .ad-component_dropdown'), (dropdownLink) => {
			if (!activeDropdown.isEqualNode(dropdownLink)) {
				dropdownLink.classList.remove('js-dropdown-active');
				var $trigger = dropdownLink.querySelector('.ad-component_dropdown--trigger');
				if ($trigger) {
					$trigger.classList.remove('ad-component_dropdown--is-active');
				}
			}
		});
		document.dispatchEvent(new CustomEvent('universalnav:hide:cart'));
		activeDropdown.setAttribute('data-tooltip-hide', 'true');
		activeDropdown.removeAttribute('data-adu-tooltip');
		activeDropdownLink.classList.toggle('ad-component_dropdown--is-active');
		activeDropdown.classList.toggle('js-dropdown-active');
		
		// Focus management - only move focus to first dropdown item when opened via keyboard
		if (!isCurrentlyActive && isKeyboardActivated) {
			setTimeout(() => {
				const firstDropdownItem = activeDropdown.querySelector('.ad-component_list .ad-component--link');
				if (firstDropdownItem) {
					firstDropdownItem.focus();
				}
			}, 10);
		}
	};

	// Click handler for dropdowns
	attachEvent('click', '.ad-universalnav .ad-component_dropdown .ad-component_dropdown--trigger', (evt, activeDropdownLink) => {
		toggleDropdown(activeDropdownLink, evt, false); // false = not keyboard activated
	});

	// Keyboard handler for opening dropdowns
	attachEvent('keydown', '.ad-universalnav .ad-component_dropdown .ad-component_dropdown--trigger', (evt, activeDropdownLink) => {
		if (evt.key === 'Enter' || evt.key === ' ') {
			evt.preventDefault();
			toggleDropdown(activeDropdownLink, evt, true); // true = keyboard activated
		} else if (evt.key === 'ArrowDown') {
			evt.preventDefault();
			// Open dropdown and focus first item
			const activeDropdown = activeDropdownLink.closest('.ad-component_dropdown');
			if (!activeDropdown.classList.contains('js-dropdown-active')) {
				toggleDropdown(activeDropdownLink, evt, true); // true = keyboard activated
			}
		} else if (evt.key === 'Tab') {
			// Close current dropdown when tabbing away from trigger
			const activeDropdown = activeDropdownLink.closest('.ad-component_dropdown');
			if (activeDropdown.classList.contains('js-dropdown-active')) {
				activeDropdown.classList.remove('js-dropdown-active');
				activeDropdownLink.classList.remove('ad-component_dropdown--is-active');
			}
			
			// Handle navigation to next/previous dropdown trigger
			evt.preventDefault();
			
			// Find all navigation elements in order
			const allNavElements = document.querySelectorAll([
				'.ad-uniheader__logo-container--link',
				'.ad-universalnav-icons .ad-icon-link',
				'.ad-universalnav-icons > .ad-icon-link',
				'a.ad-icon-link',
				'.ad-component__cart .ad-icon-link',
				'.adsearch-universal input[tabindex="0"]',
				'.ad-component_dropdown .ad-component_dropdown--trigger'
			].join(', '));
			
			const focusableArray = Array.from(allNavElements).filter(el => 
				el.getAttribute('tabindex') !== '-1' && 
				el.offsetParent !== null && // visible
				!el.disabled
			);
			
			const currentIndex = focusableArray.indexOf(activeDropdownLink);
			
			if (evt.shiftKey) {
				// Shift+Tab: move to previous element
				const prevIndex = currentIndex > 0 ? currentIndex - 1 : focusableArray.length - 1;
				if (prevIndex >= 0 && focusableArray[prevIndex]) {
					focusableArray[prevIndex].focus();
				}
			} else {
				// Tab: move to next element
				const nextIndex = currentIndex + 1;
				if (nextIndex < focusableArray.length) {
					focusableArray[nextIndex].focus();
				} else {
					// No more navigation elements, blur and let browser handle default Tab
					activeDropdownLink.blur();
				}
			}
		}
	});

	// Arrow key navigation within dropdowns
	attachEvent('keydown', '.ad-universalnav .ad-component_dropdown .ad-component_list .ad-component--link', (evt, currentItem) => {
		const dropdown = currentItem.closest('.ad-component_dropdown');
		const allItems = dropdown.querySelectorAll('.ad-component_list .ad-component--link');
		const currentIndex = Array.from(allItems).indexOf(currentItem);

		if (evt.key === 'ArrowDown') {
			evt.preventDefault();
			const nextIndex = (currentIndex + 1) % allItems.length;
			allItems[nextIndex].focus();
		} else if (evt.key === 'ArrowUp') {
			evt.preventDefault();
			const prevIndex = currentIndex === 0 ? allItems.length - 1 : currentIndex - 1;
			allItems[prevIndex].focus();
		} else if (evt.key === 'Escape') {
			evt.preventDefault();
			// Close dropdown and return focus to trigger
			dropdown.classList.remove('js-dropdown-active');
			const trigger = dropdown.querySelector('.ad-component_dropdown--trigger');
			if (trigger) {
				trigger.classList.remove('ad-component_dropdown--is-active');
				trigger.focus();
			}
		} else if (evt.key === 'Enter' || evt.key === ' ') {
			evt.preventDefault();
			currentItem.click();
		} else if (evt.key === 'Tab') {
			// Close dropdown and allow Tab to move to next focusable element
			evt.preventDefault();
			dropdown.classList.remove('js-dropdown-active');
			const trigger = dropdown.querySelector('.ad-component_dropdown--trigger');
			if (trigger) {
				trigger.classList.remove('ad-component_dropdown--is-active');
			}
			
			// Find next focusable element and move focus there
			const allFocusableElements = document.querySelectorAll(
				'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			const currentIndex = Array.from(allFocusableElements).indexOf(trigger);
			
			if (evt.shiftKey) {
				// Shift+Tab: move to previous element
				const prevIndex = currentIndex > 0 ? currentIndex - 1 : allFocusableElements.length - 1;
				allFocusableElements[prevIndex].focus();
			} else {
				// Tab: move to next element
				const nextIndex = (currentIndex + 1) % allFocusableElements.length;
				allFocusableElements[nextIndex].focus();
			}
		}
	});

	// Hide dropdown when clicking anywhere on the page
	attachEvent('click', 'body', () => {
		[].forEach.call(document.querySelectorAll('.ad-universalnav .ad-component_dropdown'), (el) => {
			el.classList.remove('js-dropdown-active');
			var trigger = el.querySelector('.ad-component_dropdown--trigger');
			if (trigger) {
				trigger.classList.remove('ad-component_dropdown--is-active');
			}
		});
		document.dispatchEvent(new CustomEvent('universalnav:hide:cart'));
	}, false);

	// Hide dropdown when tabbing away from the dropdown (fallback)
	attachEvent('keyup', 'body', (e) => {
		if (e.key === "Tab") {
			setTimeout(() => {
				// Close any dropdown that doesn't contain the currently focused element
				const allDropdowns = document.querySelectorAll('.ad-universalnav .ad-component_dropdown');
				allDropdowns.forEach((dropdown) => {
					if (!dropdown.contains(document.activeElement)) {
						dropdown.classList.remove('js-dropdown-active');
						const trigger = dropdown.querySelector('.ad-component_dropdown--trigger');
						if (trigger) {
							trigger.classList.remove('ad-component_dropdown--is-active');
						}
					}
				});
				document.dispatchEvent(new CustomEvent('universalnav:hide:cart'));
			}, 10);
		}
	}, false);
	
	// Hide dropdown when pressing Escape key globally
	attachEvent('keyup', 'body', (e) => {
		if (e.key === "Escape") {
			const menuList = document.querySelectorAll('.ad-universalnav .ad-component_dropdown');
			menuList.forEach((el) => {
				el.classList.remove('js-dropdown-active');
				const trigger = el.querySelector('.ad-component_dropdown--trigger');
				if (trigger) {
					trigger.classList.remove('ad-component_dropdown--is-active');
				}
			});
			document.dispatchEvent(new CustomEvent('universalnav:hide:cart'));
		}
	}, false);
}

const isEllipsisActive = e => e.offsetWidth < e.scrollWidth;
const ELLIPSIS_SELECTOR = '.ad-universalnav .ellipsize-overflow-text';

export function loadMouseOverEvents() {
	attachEvent('mouseover', '.ad-universalnav .js-mouseover--trigger', (evt, activeElement) => {
		if (activeElement.classList.contains('js-dropdown-active') && !activeElement.classList.contains('js-mouseover--trigger')) {
			return;
		}
		activeElement.classList.add('js-dropdown-active');
	});
	attachEvent('mouseout', '.ad-universalnav .js-mouseover--trigger', (evt, activeElement) => {
		activeElement.classList.remove('js-dropdown-active');
	});
	if (document.querySelector(ELLIPSIS_SELECTOR) && !isEllipsisActive(document.querySelector(ELLIPSIS_SELECTOR))) {
		attachEvent('mouseover', ELLIPSIS_SELECTOR, (evt, activeElement) => {
			if (activeElement.closest('li').getAttribute('data-tooltip-hide') !== 'true') {
				activeElement.closest('li').setAttribute('data-adu-tooltip', activeElement.textContent);
			}
		});
		attachEvent('mouseout', ELLIPSIS_SELECTOR, (evt, activeElement) => {
			activeElement.closest('li').removeAttribute('data-adu-tooltip');
		});
	}
}
